module.exports = __webpack_public_path__ + "img/10.b9b4f482.jpg";